<template>
  <div>
    <table>
      <tr>
        <td>Standard Anzahl Tage</td>
        <td>
          <SogDataLabel
            :value="details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration)??(person?.isBranch()?7:30)"
          />
        </td>
      </tr>
      <tr>
        <td>Maximale Anzahl Tage</td>
        <td>
          <SogDataLabel
            :value="details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration)??(person?.isBranch()?30:90)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import Person from "@/shared/model/person";

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    person: undefined,
    details: undefined
  }
)


</script>

<style scoped>
td {
  padding-right: 10px;
}

</style>
